"use client";

import { useEffect, useState } from "react";

interface TimerProps {
  isActive?: boolean;
  endTime?: number | null;
  onComplete?: () => void;
  description?: string;
}

const Timer: React.FC<TimerProps> = ({
  isActive,
  endTime,
  onComplete,
  description = "زمان باقی مانده تا ارسال درخواست بعدی :",
}) => {
  const [secondsLeft, setSecondsLeft] = useState(0);

  // Calculate seconds left based on endTime
  useEffect(() => {
    if (!isActive || !endTime) {
      setSecondsLeft(0);
      return;
    }

    const calculateSecondsLeft = () => {
      const now = Date.now();
      const remaining = Math.max(0, Math.floor((endTime - now) / 1000));
      return remaining;
    };

    // Initial calculation
    setSecondsLeft(calculateSecondsLeft());

    // Update every second
    const interval = setInterval(() => {
      const remaining = calculateSecondsLeft();
      setSecondsLeft(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
        if (onComplete) {
          onComplete();
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, endTime, onComplete]);

  if (!isActive || secondsLeft <= 0) return null;

  return (
    <div className="mt-4 overflow-hidden rounded-lg border border-blue-600 bg-blue-100/40 p-4 text-xs text-blue-600 sm:text-sm">
      <p className="text-center">
        {description}
        <span className="font-bold">
          {String(Math.floor(secondsLeft / 60)).padStart(2, "0")}:
          {String(secondsLeft % 60).padStart(2, "0")}
        </span>
      </p>
    </div>
  );
};

export default Timer;
